import * as Permissions from '@/js/libs/generated/permissions/types';
import * as Types from './types';
export var GeoFeatureDtoTypeInline;
(function (GeoFeatureDtoTypeInline) {
    GeoFeatureDtoTypeInline["Feature"] = "Feature";
})(GeoFeatureDtoTypeInline || (GeoFeatureDtoTypeInline = {}));
export var BoundariesDtoTypeInline;
(function (BoundariesDtoTypeInline) {
    BoundariesDtoTypeInline["FeatureCollection"] = "FeatureCollection";
})(BoundariesDtoTypeInline || (BoundariesDtoTypeInline = {}));
export var ScoreDtoGradationInline;
(function (ScoreDtoGradationInline) {
    ScoreDtoGradationInline["HIGH"] = "HIGH";
    ScoreDtoGradationInline["MEDIUM"] = "MEDIUM";
    ScoreDtoGradationInline["LOW"] = "LOW";
    ScoreDtoGradationInline["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(ScoreDtoGradationInline || (ScoreDtoGradationInline = {}));
export var DigitalAdPressureStrengthInline;
(function (DigitalAdPressureStrengthInline) {
    DigitalAdPressureStrengthInline["REGULAR"] = "REGULAR";
    DigitalAdPressureStrengthInline["STRONG"] = "STRONG";
    DigitalAdPressureStrengthInline["STRONG_PLUS"] = "STRONG_PLUS";
    DigitalAdPressureStrengthInline["INDIVIDUAL"] = "INDIVIDUAL";
})(DigitalAdPressureStrengthInline || (DigitalAdPressureStrengthInline = {}));
export var FeatureToggleKeyDto;
(function (FeatureToggleKeyDto) {
    FeatureToggleKeyDto["MANUAL_POST_INVOICING"] = "MANUAL_POST_INVOICING";
    FeatureToggleKeyDto["ONLINE_VALIDATION"] = "ONLINE_VALIDATION";
    FeatureToggleKeyDto["SCREEN_RESTRICTIONS"] = "SCREEN_RESTRICTIONS";
    FeatureToggleKeyDto["ACCOUNTING_NUMBER"] = "ACCOUNTING_NUMBER";
    FeatureToggleKeyDto["POSITION_OVERWRITING"] = "POSITION_OVERWRITING";
    FeatureToggleKeyDto["BRIEFING_EML"] = "BRIEFING_EML";
    FeatureToggleKeyDto["DEFAULT_SERVICE_PRODUCT_DISCOUNT"] = "DEFAULT_SERVICE_PRODUCT_DISCOUNT";
    FeatureToggleKeyDto["DEFAULT_ONLINE_LINE_ITEMS_MAX_CAPACITY"] = "DEFAULT_ONLINE_LINE_ITEMS_MAX_CAPACITY";
    FeatureToggleKeyDto["REACH"] = "REACH";
    FeatureToggleKeyDto["ONLINE_POSITIONS_OVERBOOKING_VALIDATION"] = "ONLINE_POSITIONS_OVERBOOKING_VALIDATION";
    FeatureToggleKeyDto["EXISTING_CUSTOMERS"] = "EXISTING_CUSTOMERS";
    FeatureToggleKeyDto["POSTRON_MOBILE_IN_APP_DISPLAY_SUPPRESSION"] = "POSTRON_MOBILE_IN_APP_DISPLAY_SUPPRESSION";
    FeatureToggleKeyDto["POSTRON_MOBILE_IN_APP_DISPLAY_HIDING"] = "POSTRON_MOBILE_IN_APP_DISPLAY_HIDING";
    FeatureToggleKeyDto["DYNAMIC_CAMPAIGN_MANAGEMENT_GROSS"] = "DYNAMIC_CAMPAIGN_MANAGEMENT_GROSS";
    FeatureToggleKeyDto["DYNAMIC_DOOH"] = "DYNAMIC_DOOH";
    FeatureToggleKeyDto["SUPPORT_LIVESYSTEMS_API_V2"] = "SUPPORT_LIVESYSTEMS_API_V2";
    FeatureToggleKeyDto["DYNAMIC_DOOH_POSITIONS"] = "DYNAMIC_DOOH_POSITIONS";
})(FeatureToggleKeyDto || (FeatureToggleKeyDto = {}));
export var ProblemDetailsType;
(function (ProblemDetailsType) {
    ProblemDetailsType["ABOUT_BLANK"] = "ABOUT_BLANK";
})(ProblemDetailsType || (ProblemDetailsType = {}));
export var PostCampaignStage;
(function (PostCampaignStage) {
    PostCampaignStage["OFFERED"] = "OFFERED";
    PostCampaignStage["OFFER_DENIED"] = "OFFER_DENIED";
    PostCampaignStage["ALTERNATE_QUOTE"] = "ALTERNATE_QUOTE";
    PostCampaignStage["BOOKED"] = "BOOKED";
})(PostCampaignStage || (PostCampaignStage = {}));
export var PostCampaignStatus;
(function (PostCampaignStatus) {
    PostCampaignStatus["ALL"] = "ALL";
    PostCampaignStatus["UNFINISHED"] = "UNFINISHED";
    PostCampaignStatus["OFFERED"] = "OFFERED";
    PostCampaignStatus["BOOKED"] = "BOOKED";
    PostCampaignStatus["RUNNING"] = "RUNNING";
    PostCampaignStatus["ARCHIVED"] = "ARCHIVED";
})(PostCampaignStatus || (PostCampaignStatus = {}));
export var PostCampaignPurpose;
(function (PostCampaignPurpose) {
    PostCampaignPurpose["PERFORMANCE_SALES"] = "PERFORMANCE_SALES";
    PostCampaignPurpose["AWARENESS_BRANDING"] = "AWARENESS_BRANDING";
})(PostCampaignPurpose || (PostCampaignPurpose = {}));
export var CampaignContentDto;
(function (CampaignContentDto) {
    CampaignContentDto["WORK_FINANCES"] = "WORK_FINANCES";
    CampaignContentDto["AUTO_MOBILITY"] = "AUTO_MOBILITY";
    CampaignContentDto["BEAUTY_FASHION"] = "BEAUTY_FASHION";
    CampaignContentDto["SOCIETY_POLITICS"] = "SOCIETY_POLITICS";
    CampaignContentDto["HEALTH"] = "HEALTH";
    CampaignContentDto["PETS"] = "PETS";
    CampaignContentDto["IT_MULTIMEDIA"] = "IT_MULTIMEDIA";
    CampaignContentDto["LIFE_HOME"] = "LIFE_HOME";
    CampaignContentDto["FOOD"] = "FOOD";
    CampaignContentDto["MUSIC_READING_CULTURE"] = "MUSIC_READING_CULTURE";
    CampaignContentDto["SUSTAINABILITY_CHARITY"] = "SUSTAINABILITY_CHARITY";
    CampaignContentDto["TRAVEL_TOURISM_EVENTS"] = "TRAVEL_TOURISM_EVENTS";
    CampaignContentDto["TOYS_GIFTS"] = "TOYS_GIFTS";
    CampaignContentDto["SPORT"] = "SPORT";
})(CampaignContentDto || (CampaignContentDto = {}));
export var DigitalAdChannel;
(function (DigitalAdChannel) {
    DigitalAdChannel["SCREENS_PUBLIC_TRANSPORT"] = "SCREENS_PUBLIC_TRANSPORT";
    DigitalAdChannel["SCREENS_CITY"] = "SCREENS_CITY";
    DigitalAdChannel["SCREENS_RETAIL"] = "SCREENS_RETAIL";
    DigitalAdChannel["SCREENS_IN_STORE"] = "SCREENS_IN_STORE";
    DigitalAdChannel["SCREENS_GAS_STATION"] = "SCREENS_GAS_STATION";
    DigitalAdChannel["null"] = "null";
})(DigitalAdChannel || (DigitalAdChannel = {}));
export var OnlineAdChannelEnum;
(function (OnlineAdChannelEnum) {
    OnlineAdChannelEnum["POSTADVERTISING"] = "POSTADVERTISING";
    OnlineAdChannelEnum["REACH"] = "REACH";
})(OnlineAdChannelEnum || (OnlineAdChannelEnum = {}));
export var MailingType;
(function (MailingType) {
    MailingType["COMMERCIAL"] = "COMMERCIAL";
    MailingType["OFFICIAL"] = "OFFICIAL";
})(MailingType || (MailingType = {}));
export var AddressProvider;
(function (AddressProvider) {
    AddressProvider["POST"] = "POST";
    AddressProvider["KUBA"] = "KUBA";
    AddressProvider["AZ"] = "AZ";
})(AddressProvider || (AddressProvider = {}));
export var StopStickerCriterion;
(function (StopStickerCriterion) {
    StopStickerCriterion["ANY"] = "ANY";
    StopStickerCriterion["WITH_STOP_STICKER"] = "WITH_STOP_STICKER";
    StopStickerCriterion["WITHOUT_STOP_STICKER"] = "WITHOUT_STOP_STICKER";
})(StopStickerCriterion || (StopStickerCriterion = {}));
export var DispatchType;
(function (DispatchType) {
    DispatchType["A"] = "A";
    DispatchType["B"] = "B";
    DispatchType["B2"] = "B2";
})(DispatchType || (DispatchType = {}));
export var DispatchMailFormat;
(function (DispatchMailFormat) {
    DispatchMailFormat["POSTCARD"] = "POSTCARD";
    DispatchMailFormat["STANDARD_LETTER"] = "STANDARD_LETTER";
    DispatchMailFormat["MIDI_LETTER"] = "MIDI_LETTER";
    DispatchMailFormat["LARGE_FORMAT_LETTER"] = "LARGE_FORMAT_LETTER";
})(DispatchMailFormat || (DispatchMailFormat = {}));
export var RedeliveryChannel;
(function (RedeliveryChannel) {
    RedeliveryChannel["PHYSICAL_ADDRESSED_MAILING"] = "PHYSICAL_ADDRESSED_MAILING";
    RedeliveryChannel["EMAIL"] = "EMAIL";
})(RedeliveryChannel || (RedeliveryChannel = {}));
export var PhysicalAddressedMailingType;
(function (PhysicalAddressedMailingType) {
    PhysicalAddressedMailingType["A"] = "A";
    PhysicalAddressedMailingType["B"] = "B";
    PhysicalAddressedMailingType["B2"] = "B2";
})(PhysicalAddressedMailingType || (PhysicalAddressedMailingType = {}));
export var AdvertisingMedium;
(function (AdvertisingMedium) {
    AdvertisingMedium["STANDARD_LETTER"] = "STANDARD_LETTER";
    AdvertisingMedium["MIDI_LETTER"] = "MIDI_LETTER";
    AdvertisingMedium["LARGE_FORMAT_LETTER"] = "LARGE_FORMAT_LETTER";
    AdvertisingMedium["POSTCARD"] = "POSTCARD";
})(AdvertisingMedium || (AdvertisingMedium = {}));
export var OnlineDeviceDto;
(function (OnlineDeviceDto) {
    OnlineDeviceDto["MOBILE_WEB"] = "MOBILE_WEB";
    OnlineDeviceDto["DESKTOP"] = "DESKTOP";
    OnlineDeviceDto["MOBILE_INAPP"] = "MOBILE_INAPP";
})(OnlineDeviceDto || (OnlineDeviceDto = {}));
export var OnlineFormatDto;
(function (OnlineFormatDto) {
    OnlineFormatDto["DISPLAY"] = "DISPLAY";
    OnlineFormatDto["INTERSTITIAL"] = "INTERSTITIAL";
    OnlineFormatDto["INTERSTITIALVIDEOUNSKIPPABLE"] = "INTERSTITIALVIDEOUNSKIPPABLE";
    OnlineFormatDto["INTERSTITIALVIDEOSKIPPABLE"] = "INTERSTITIALVIDEOSKIPPABLE";
})(OnlineFormatDto || (OnlineFormatDto = {}));
export var OnlineInventoryDto;
(function (OnlineInventoryDto) {
    OnlineInventoryDto["PCC"] = "PCC";
    OnlineInventoryDto["POSTRON"] = "POSTRON";
})(OnlineInventoryDto || (OnlineInventoryDto = {}));
export var LivingEnvironment;
(function (LivingEnvironment) {
    LivingEnvironment["URBAN"] = "URBAN";
    LivingEnvironment["INTERMEDIATE"] = "INTERMEDIATE";
    LivingEnvironment["RURAL"] = "RURAL";
})(LivingEnvironment || (LivingEnvironment = {}));
export var LanguageRegion;
(function (LanguageRegion) {
    LanguageRegion["GERMAN"] = "GERMAN";
    LanguageRegion["FRENCH"] = "FRENCH";
    LanguageRegion["ITALIAN"] = "ITALIAN";
    LanguageRegion["ROMANSH"] = "ROMANSH";
})(LanguageRegion || (LanguageRegion = {}));
export var GenderTarget;
(function (GenderTarget) {
    GenderTarget["MALE"] = "MALE";
    GenderTarget["FEMALE"] = "FEMALE";
})(GenderTarget || (GenderTarget = {}));
export var Language;
(function (Language) {
    Language["GERMAN"] = "GERMAN";
    Language["FRENCH"] = "FRENCH";
    Language["ITALIAN"] = "ITALIAN";
})(Language || (Language = {}));
export var AgeTarget;
(function (AgeTarget) {
    AgeTarget["ZERO"] = "ZERO";
    AgeTarget["FIVE"] = "FIVE";
    AgeTarget["TEN"] = "TEN";
    AgeTarget["FIFTEEN"] = "FIFTEEN";
    AgeTarget["TWENTY"] = "TWENTY";
    AgeTarget["TWENTY_FIVE"] = "TWENTY_FIVE";
    AgeTarget["THIRTY"] = "THIRTY";
    AgeTarget["THIRTY_FIVE"] = "THIRTY_FIVE";
    AgeTarget["FORTY"] = "FORTY";
    AgeTarget["FORTY_FIVE"] = "FORTY_FIVE";
    AgeTarget["FIFTY"] = "FIFTY";
    AgeTarget["FIFTY_FIVE"] = "FIFTY_FIVE";
    AgeTarget["SIXTY"] = "SIXTY";
    AgeTarget["SIXTY_FIVE"] = "SIXTY_FIVE";
    AgeTarget["SEVENTY"] = "SEVENTY";
    AgeTarget["SEVENTY_FIVE"] = "SEVENTY_FIVE";
    AgeTarget["EIGHTY"] = "EIGHTY";
    AgeTarget["EIGHTY_FIVE"] = "EIGHTY_FIVE";
    AgeTarget["NINETY"] = "NINETY";
    AgeTarget["NINETY_PLUS"] = "NINETY_PLUS";
})(AgeTarget || (AgeTarget = {}));
export var IncomeTarget;
(function (IncomeTarget) {
    IncomeTarget["ZERO"] = "ZERO";
    IncomeTarget["TWENTY_FIVE"] = "TWENTY_FIVE";
    IncomeTarget["FORTY"] = "FORTY";
    IncomeTarget["SIXTY"] = "SIXTY";
    IncomeTarget["EIGHTY"] = "EIGHTY";
    IncomeTarget["ONE_HUNDRED"] = "ONE_HUNDRED";
    IncomeTarget["ONE_HUNDRED_FIFTY"] = "ONE_HUNDRED_FIFTY";
    IncomeTarget["THREE_HUNDRED"] = "THREE_HUNDRED";
    IncomeTarget["TREE_HUNDRED_PLUS"] = "TREE_HUNDRED_PLUS";
})(IncomeTarget || (IncomeTarget = {}));
export var HouseholdSizeTarget;
(function (HouseholdSizeTarget) {
    HouseholdSizeTarget["ONE"] = "ONE";
    HouseholdSizeTarget["TWO"] = "TWO";
    HouseholdSizeTarget["THREE"] = "THREE";
    HouseholdSizeTarget["FOUR"] = "FOUR";
    HouseholdSizeTarget["FIVE"] = "FIVE";
    HouseholdSizeTarget["SIX"] = "SIX";
})(HouseholdSizeTarget || (HouseholdSizeTarget = {}));
export var AffinityTarget;
(function (AffinityTarget) {
    AffinityTarget["CAR_MOTORBIKE"] = "CAR_MOTORBIKE";
    AffinityTarget["BANKING_FINANCE"] = "BANKING_FINANCE";
    AffinityTarget["BEAUTY"] = "BEAUTY";
    AffinityTarget["DECORATION"] = "DECORATION";
    AffinityTarget["TECHNOLOGY_COMPUTERS_CONSUMER_ELECTRONICS"] = "TECHNOLOGY_COMPUTERS_CONSUMER_ELECTRONICS";
    AffinityTarget["PARENTING"] = "PARENTING";
    AffinityTarget["PHOTOGRAPHY"] = "PHOTOGRAPHY";
    AffinityTarget["GARDENING_BALCONY"] = "GARDENING_BALCONY";
    AffinityTarget["LEISURE_HANDIWORK"] = "LEISURE_HANDIWORK";
    AffinityTarget["HOMEOWNER"] = "HOMEOWNER";
    AffinityTarget["DO_IT_YOURSELF"] = "DO_IT_YOURSELF";
    AffinityTarget["PETS"] = "PETS";
    AffinityTarget["COFFEE_TEA"] = "COFFEE_TEA";
    AffinityTarget["COOKING"] = "COOKING";
    AffinityTarget["BOOKS_LITERATURE"] = "BOOKS_LITERATURE";
    AffinityTarget["JEWELRY"] = "JEWELRY";
    AffinityTarget["GLASSES_SUNGLASSES"] = "GLASSES_SUNGLASSES";
    AffinityTarget["TOYS_GAMES"] = "TOYS_GAMES";
    AffinityTarget["SPORTS"] = "SPORTS";
    AffinityTarget["BICYCLE"] = "BICYCLE";
    AffinityTarget["MUSIC_VIDEO_MOVIES"] = "MUSIC_VIDEO_MOVIES";
    AffinityTarget["VINTAGE_SECOND_HAND"] = "VINTAGE_SECOND_HAND";
    AffinityTarget["WINE_DRINKS"] = "WINE_DRINKS";
    AffinityTarget["FASHION_STYLE"] = "FASHION_STYLE";
    AffinityTarget["MOBILE_PHONE"] = "MOBILE_PHONE";
    AffinityTarget["FOOD_RETAIL"] = "FOOD_RETAIL";
    AffinityTarget["FOOD_RESTAURANTS"] = "FOOD_RESTAURANTS";
    AffinityTarget["ALTERNATIVE_FOOD_BIO"] = "ALTERNATIVE_FOOD_BIO";
    AffinityTarget["FURNITURE"] = "FURNITURE";
    AffinityTarget["NON_PROFIT_ORGANIZATION"] = "NON_PROFIT_ORGANIZATION";
    AffinityTarget["PHARMACY"] = "PHARMACY";
    AffinityTarget["ECOMMERCE_MAIL_ORDER"] = "ECOMMERCE_MAIL_ORDER";
    AffinityTarget["SUSTAINABILITY"] = "SUSTAINABILITY";
    AffinityTarget["TRAVELING"] = "TRAVELING";
    AffinityTarget["ONLINE_FOOD"] = "ONLINE_FOOD";
})(AffinityTarget || (AffinityTarget = {}));
export var ImportType;
(function (ImportType) {
    ImportType["FOUR_DIGITS"] = "FOUR_DIGITS";
    ImportType["SIX_DIGITS"] = "SIX_DIGITS";
})(ImportType || (ImportType = {}));
export var PostCampaignChannel;
(function (PostCampaignChannel) {
    PostCampaignChannel["POSTCODE"] = "POSTCODE";
    PostCampaignChannel["DOOH_SCREEN_ZONE"] = "DOOH_SCREEN_ZONE";
})(PostCampaignChannel || (PostCampaignChannel = {}));
export var ScoreGradation;
(function (ScoreGradation) {
    ScoreGradation["HIGH"] = "HIGH";
    ScoreGradation["MEDIUM"] = "MEDIUM";
    ScoreGradation["LOW"] = "LOW";
})(ScoreGradation || (ScoreGradation = {}));
export var OverlappingDto;
(function (OverlappingDto) {
    OverlappingDto["BROAD"] = "BROAD";
    OverlappingDto["NARROW"] = "NARROW";
})(OverlappingDto || (OverlappingDto = {}));
export var MailingProduct;
(function (MailingProduct) {
    MailingProduct["PRIVATE_CUSTOMERS"] = "PRIVATE_CUSTOMERS";
    MailingProduct["PRIVATE_AND_BUSINESS_CUSTOMERS"] = "PRIVATE_AND_BUSINESS_CUSTOMERS";
    MailingProduct["ONE_AND_TWO_FAMILY_HOUSES"] = "ONE_AND_TWO_FAMILY_HOUSES";
    MailingProduct["AGRICULTURAL_BUSINESSES"] = "AGRICULTURAL_BUSINESSES";
    MailingProduct["PRIVATE_AND_BUSINESS_MAILBOXES"] = "PRIVATE_AND_BUSINESS_MAILBOXES";
})(MailingProduct || (MailingProduct = {}));
export var Canton;
(function (Canton) {
    Canton["AG"] = "AG";
    Canton["AI"] = "AI";
    Canton["AR"] = "AR";
    Canton["BE"] = "BE";
    Canton["BL"] = "BL";
    Canton["BS"] = "BS";
    Canton["FR"] = "FR";
    Canton["GE"] = "GE";
    Canton["GL"] = "GL";
    Canton["GR"] = "GR";
    Canton["JU"] = "JU";
    Canton["LU"] = "LU";
    Canton["NE"] = "NE";
    Canton["NW"] = "NW";
    Canton["OW"] = "OW";
    Canton["SG"] = "SG";
    Canton["SH"] = "SH";
    Canton["SO"] = "SO";
    Canton["SZ"] = "SZ";
    Canton["TG"] = "TG";
    Canton["TI"] = "TI";
    Canton["UR"] = "UR";
    Canton["VD"] = "VD";
    Canton["VS"] = "VS";
    Canton["ZG"] = "ZG";
    Canton["ZH"] = "ZH";
})(Canton || (Canton = {}));
export var AdTypeEnum;
(function (AdTypeEnum) {
    AdTypeEnum["DIGITAL"] = "DIGITAL";
    AdTypeEnum["UNADDRESSED_MAILING"] = "UNADDRESSED_MAILING";
    AdTypeEnum["EMAIL"] = "EMAIL";
    AdTypeEnum["ADDRESSED_MAILING"] = "ADDRESSED_MAILING";
    AdTypeEnum["ONLINE"] = "ONLINE";
})(AdTypeEnum || (AdTypeEnum = {}));
export var AdChannelTypeEnum;
(function (AdChannelTypeEnum) {
    AdChannelTypeEnum["EMAIL"] = "EMAIL";
    AdChannelTypeEnum["PHYSICAL_ADDRESSED_MAILING"] = "PHYSICAL_ADDRESSED_MAILING";
    AdChannelTypeEnum["POSTCODE"] = "POSTCODE";
    AdChannelTypeEnum["DOOH_SCREEN_ZONE"] = "DOOH_SCREEN_ZONE";
    AdChannelTypeEnum["ONLINE"] = "ONLINE";
})(AdChannelTypeEnum || (AdChannelTypeEnum = {}));
export var AdChannelSubTypeEnum;
(function (AdChannelSubTypeEnum) {
    AdChannelSubTypeEnum["SCREENS_ALL"] = "SCREENS_ALL";
    AdChannelSubTypeEnum["SCREENS_CITY"] = "SCREENS_CITY";
    AdChannelSubTypeEnum["SCREENS_GAS_STATION"] = "SCREENS_GAS_STATION";
    AdChannelSubTypeEnum["SCREENS_RETAIL"] = "SCREENS_RETAIL";
    AdChannelSubTypeEnum["SCREENS_IN_STORE"] = "SCREENS_IN_STORE";
    AdChannelSubTypeEnum["SCREENS_PUBLIC_TRANSPORT"] = "SCREENS_PUBLIC_TRANSPORT";
    AdChannelSubTypeEnum["PROMOPOST"] = "PROMOPOST";
    AdChannelSubTypeEnum["POSTADVERTISING"] = "POSTADVERTISING";
    AdChannelSubTypeEnum["REACH"] = "REACH";
})(AdChannelSubTypeEnum || (AdChannelSubTypeEnum = {}));
export var AdChannelEnum;
(function (AdChannelEnum) {
    AdChannelEnum["SCREENS_CITY"] = "SCREENS_CITY";
    AdChannelEnum["SCREENS_GAS_STATION"] = "SCREENS_GAS_STATION";
    AdChannelEnum["SCREENS_RETAIL"] = "SCREENS_RETAIL";
    AdChannelEnum["SCREENS_IN_STORE"] = "SCREENS_IN_STORE";
    AdChannelEnum["SCREENS_PUBLIC_TRANSPORT"] = "SCREENS_PUBLIC_TRANSPORT";
    AdChannelEnum["PROMOPOST"] = "PROMOPOST";
    AdChannelEnum["POSTADVERTISING"] = "POSTADVERTISING";
    AdChannelEnum["REACH"] = "REACH";
})(AdChannelEnum || (AdChannelEnum = {}));
export var AddressedPositionTypeEnum;
(function (AddressedPositionTypeEnum) {
    AddressedPositionTypeEnum["INITIAL_EMAIL"] = "INITIAL_EMAIL";
    AddressedPositionTypeEnum["INITIAL_ADDRESSED"] = "INITIAL_ADDRESSED";
    AddressedPositionTypeEnum["INITIAL_SHIPMENT"] = "INITIAL_SHIPMENT";
    AddressedPositionTypeEnum["REMINDER_EMAIL"] = "REMINDER_EMAIL";
    AddressedPositionTypeEnum["REMINDER_ADDRESSED"] = "REMINDER_ADDRESSED";
    AddressedPositionTypeEnum["REMINDER_SHIPMENT"] = "REMINDER_SHIPMENT";
})(AddressedPositionTypeEnum || (AddressedPositionTypeEnum = {}));
export var GradationDto;
(function (GradationDto) {
    GradationDto["HIGH"] = "HIGH";
    GradationDto["MEDIUM"] = "MEDIUM";
    GradationDto["LOW"] = "LOW";
    GradationDto["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(GradationDto || (GradationDto = {}));
export var ChannelAdUnitSortField;
(function (ChannelAdUnitSortField) {
    ChannelAdUnitSortField["SELECTED_STATE_FIELD"] = "SELECTED_STATE_FIELD";
    ChannelAdUnitSortField["ID_PLZ_FIELD"] = "ID_PLZ_FIELD";
    ChannelAdUnitSortField["PLZ_4_FIELD"] = "PLZ_4_FIELD";
    ChannelAdUnitSortField["AD_CHANNEL_SUB_TYPE_FIELD"] = "AD_CHANNEL_SUB_TYPE_FIELD";
    ChannelAdUnitSortField["LOCATION_NAME_FIELD"] = "LOCATION_NAME_FIELD";
    ChannelAdUnitSortField["CANTON_FIELD"] = "CANTON_FIELD";
    ChannelAdUnitSortField["SCORE_GRADATION_FIELD"] = "SCORE_GRADATION_FIELD";
    ChannelAdUnitSortField["REACH_VALUE_FIELD"] = "REACH_VALUE_FIELD";
    ChannelAdUnitSortField["NET_PRICE_FIELD"] = "NET_PRICE_FIELD";
    ChannelAdUnitSortField["SCORE_VALUE_FIELD"] = "SCORE_VALUE_FIELD";
    ChannelAdUnitSortField["SCREENS_NUMBER_FIELD"] = "SCREENS_NUMBER_FIELD";
    ChannelAdUnitSortField["DELIVERIES_NUMBER_FIELD"] = "DELIVERIES_NUMBER_FIELD";
})(ChannelAdUnitSortField || (ChannelAdUnitSortField = {}));
export var AdUnitExportField;
(function (AdUnitExportField) {
    AdUnitExportField["SELECTED_STATE_FIELD"] = "SELECTED_STATE_FIELD";
    AdUnitExportField["ID_PLZ_FIELD"] = "ID_PLZ_FIELD";
    AdUnitExportField["PLZ_4_FIELD"] = "PLZ_4_FIELD";
    AdUnitExportField["AD_CHANNEL_SUBTYPE_FIELD"] = "AD_CHANNEL_SUBTYPE_FIELD";
    AdUnitExportField["PLACEMENT_FIELD"] = "PLACEMENT_FIELD";
    AdUnitExportField["CANTON_FIELD"] = "CANTON_FIELD";
    AdUnitExportField["REACH_LANGUAGE_FIELD"] = "REACH_LANGUAGE_FIELD";
    AdUnitExportField["SCORE_GRADATION_FIELD"] = "SCORE_GRADATION_FIELD";
    AdUnitExportField["SUGGESTED_FIELD"] = "SUGGESTED_FIELD";
    AdUnitExportField["REACH_VALUE_FIELD"] = "REACH_VALUE_FIELD";
    AdUnitExportField["NET_PRICE_FIELD"] = "NET_PRICE_FIELD";
    AdUnitExportField["SCORE_VALUE_FIELD"] = "SCORE_VALUE_FIELD";
    AdUnitExportField["SCREENS_NUMBER_FIELD"] = "SCREENS_NUMBER_FIELD";
    AdUnitExportField["DELIVERIES_NUMBER_FIELD"] = "DELIVERIES_NUMBER_FIELD";
})(AdUnitExportField || (AdUnitExportField = {}));
export var AdUnitDetailsFetchStatus;
(function (AdUnitDetailsFetchStatus) {
    AdUnitDetailsFetchStatus["PENDING"] = "PENDING";
    AdUnitDetailsFetchStatus["DONE"] = "DONE";
    AdUnitDetailsFetchStatus["ERROR"] = "ERROR";
})(AdUnitDetailsFetchStatus || (AdUnitDetailsFetchStatus = {}));
export var FrequencyCappingDto;
(function (FrequencyCappingDto) {
    FrequencyCappingDto["DAY"] = "DAY";
    FrequencyCappingDto["MONTH"] = "MONTH";
    FrequencyCappingDto["YEAR"] = "YEAR";
})(FrequencyCappingDto || (FrequencyCappingDto = {}));
export var RadiusUnit;
(function (RadiusUnit) {
    RadiusUnit["KM"] = "KM";
    RadiusUnit["MINUTES"] = "MINUTES";
})(RadiusUnit || (RadiusUnit = {}));
export var TaskChannel;
(function (TaskChannel) {
    TaskChannel["EMAIL"] = "EMAIL";
    TaskChannel["SERVICE"] = "SERVICE";
    TaskChannel["DIGITAL"] = "DIGITAL";
    TaskChannel["ONLINE"] = "ONLINE";
    TaskChannel["ADDRESSED"] = "ADDRESSED";
    TaskChannel["UNADDRESSED"] = "UNADDRESSED";
})(TaskChannel || (TaskChannel = {}));
export var TaskPhase;
(function (TaskPhase) {
    TaskPhase["PREPARATION"] = "PREPARATION";
    TaskPhase["PLAYOUT"] = "PLAYOUT";
    TaskPhase["POSTPROCESSING"] = "POSTPROCESSING";
})(TaskPhase || (TaskPhase = {}));
export var TaskType;
(function (TaskType) {
    TaskType["MILESTONE"] = "MILESTONE";
    TaskType["ACTIVITY"] = "ACTIVITY";
    TaskType["RELEASE"] = "RELEASE";
})(TaskType || (TaskType = {}));
export var MailingBundleSizeEnum;
(function (MailingBundleSizeEnum) {
    MailingBundleSizeEnum["TEN"] = "TEN";
    MailingBundleSizeEnum["TWENTY_FIVE"] = "TWENTY_FIVE";
    MailingBundleSizeEnum["FIFTY"] = "FIFTY";
    MailingBundleSizeEnum["ONE_HUNDRED"] = "ONE_HUNDRED";
    MailingBundleSizeEnum["ONE_HUNDRED_FIFTY"] = "ONE_HUNDRED_FIFTY";
    MailingBundleSizeEnum["TWO_HUNDRED"] = "TWO_HUNDRED";
    MailingBundleSizeEnum["TWO_HUNDRED_FIFTY"] = "TWO_HUNDRED_FIFTY";
})(MailingBundleSizeEnum || (MailingBundleSizeEnum = {}));
export var MailingShipmentFormatEnum;
(function (MailingShipmentFormatEnum) {
    MailingShipmentFormatEnum["DIN_A4"] = "DIN_A4";
    MailingShipmentFormatEnum["DIN_A5"] = "DIN_A5";
    MailingShipmentFormatEnum["DIFFERENT"] = "DIFFERENT";
})(MailingShipmentFormatEnum || (MailingShipmentFormatEnum = {}));
export var InvoiceStateEnum;
(function (InvoiceStateEnum) {
    InvoiceStateEnum["OPEN"] = "OPEN";
    InvoiceStateEnum["CHARGED"] = "CHARGED";
    InvoiceStateEnum["MANUALLY_CHARGED"] = "MANUALLY_CHARGED";
    InvoiceStateEnum["NOT_CREATED"] = "NOT_CREATED";
    InvoiceStateEnum["CANCELED"] = "CANCELED";
})(InvoiceStateEnum || (InvoiceStateEnum = {}));
export var InvoicePositionTypeEnum;
(function (InvoicePositionTypeEnum) {
    InvoicePositionTypeEnum["DIGITAL"] = "DIGITAL";
    InvoicePositionTypeEnum["UNADDRESSED"] = "UNADDRESSED";
    InvoicePositionTypeEnum["ADDRESSED"] = "ADDRESSED";
    InvoicePositionTypeEnum["EMAIL"] = "EMAIL";
    InvoicePositionTypeEnum["ONLINE"] = "ONLINE";
    InvoicePositionTypeEnum["SERVICE"] = "SERVICE";
    InvoicePositionTypeEnum["DISCOUNT"] = "DISCOUNT";
})(InvoicePositionTypeEnum || (InvoicePositionTypeEnum = {}));
export var LockingReasonEnum;
(function (LockingReasonEnum) {
    LockingReasonEnum["INVOICE_CHARGED"] = "INVOICE_CHARGED";
})(LockingReasonEnum || (LockingReasonEnum = {}));
export var ExistingCustomersState;
(function (ExistingCustomersState) {
    ExistingCustomersState["COMPUTED"] = "COMPUTED";
    ExistingCustomersState["NOT_COMPUTED"] = "NOT_COMPUTED";
    ExistingCustomersState["NOT_AVAILABLE"] = "NOT_AVAILABLE";
})(ExistingCustomersState || (ExistingCustomersState = {}));
export var MediaSortType;
(function (MediaSortType) {
    MediaSortType["UNADDRESSED_MAILINGS"] = "UNADDRESSED_MAILINGS";
    MediaSortType["DIGITAL_POSITIONS"] = "DIGITAL_POSITIONS";
    MediaSortType["ADDRESSED_MAILINGS"] = "ADDRESSED_MAILINGS";
    MediaSortType["EMAILS"] = "EMAILS";
    MediaSortType["ONLINE_POSITIONS"] = "ONLINE_POSITIONS";
    MediaSortType["SERVICE_POSITIONS"] = "SERVICE_POSITIONS";
    MediaSortType["DISCOUNT_POSITIONS"] = "DISCOUNT_POSITIONS";
})(MediaSortType || (MediaSortType = {}));
export var TaskTemplateNameEnum;
(function (TaskTemplateNameEnum) {
    TaskTemplateNameEnum["REMOVE_AREA"] = "REMOVE_AREA";
    TaskTemplateNameEnum["ADDRESS_MATCHING"] = "ADDRESS_MATCHING";
    TaskTemplateNameEnum["ADDRESS_PREPARATION_FOR_PRINT"] = "ADDRESS_PREPARATION_FOR_PRINT";
    TaskTemplateNameEnum["ADVERTISEMENT_ANALYSIS"] = "ADVERTISEMENT_ANALYSIS";
    TaskTemplateNameEnum["DELIVER_BRIEFING_FOR_ARTICLE_AND_DOOH"] = "DELIVER_BRIEFING_FOR_ARTICLE_AND_DOOH";
    TaskTemplateNameEnum["DELIVER_BRIEFING_FOR_ARTICLE_AND_TEASER"] = "DELIVER_BRIEFING_FOR_ARTICLE_AND_TEASER";
    TaskTemplateNameEnum["DELIVER_BRIEFING_FOR_AD_CREATION"] = "DELIVER_BRIEFING_FOR_AD_CREATION";
    TaskTemplateNameEnum["DELIVER_EXCLUSION_ADDRESSES"] = "DELIVER_EXCLUSION_ADDRESSES";
    TaskTemplateNameEnum["DELIVER_FLYER_POST_OFFICE"] = "DELIVER_FLYER_POST_OFFICE";
    TaskTemplateNameEnum["DELIVER_INPUT_FORM_WITH_AD"] = "DELIVER_INPUT_FORM_WITH_AD";
    TaskTemplateNameEnum["DELIVER_AD"] = "DELIVER_AD";
    TaskTemplateNameEnum["DELIVER_AD_EMAIL"] = "DELIVER_AD_EMAIL";
    TaskTemplateNameEnum["DELIVER_AD_EMAIL_INITIAL"] = "DELIVER_AD_EMAIL_INITIAL";
    TaskTemplateNameEnum["DELIVER_AD_EMAIL_REMINDER"] = "DELIVER_AD_EMAIL_REMINDER";
    TaskTemplateNameEnum["DELIVER_AD_FOR_ANALYSIS"] = "DELIVER_AD_FOR_ANALYSIS";
    TaskTemplateNameEnum["DELIVER_AD_FOR_PRINT"] = "DELIVER_AD_FOR_PRINT";
    TaskTemplateNameEnum["PUBLISH_ARTICLE_AND_DOOH"] = "PUBLISH_ARTICLE_AND_DOOH";
    TaskTemplateNameEnum["PUBLISH_ARTICLE_AND_TEASER"] = "PUBLISH_ARTICLE_AND_TEASER";
    TaskTemplateNameEnum["SET_UP_POSTERS"] = "SET_UP_POSTERS";
    TaskTemplateNameEnum["CAMPAIGN_DELIVERY"] = "CAMPAIGN_DELIVERY";
    TaskTemplateNameEnum["DISPLAY_DELIVERY"] = "DISPLAY_DELIVERY";
    TaskTemplateNameEnum["DOOH_DELIVERY"] = "DOOH_DELIVERY";
    TaskTemplateNameEnum["F12D_DELIVERY"] = "F12D_DELIVERY";
    TaskTemplateNameEnum["INMAIL_BANNER_DELIVERY"] = "INMAIL_BANNER_DELIVERY";
    TaskTemplateNameEnum["ONLINE_DELIVERY"] = "ONLINE_DELIVERY";
    TaskTemplateNameEnum["SBB_ADS_DELIVERY"] = "SBB_ADS_DELIVERY";
    TaskTemplateNameEnum["DATA_SELECTION_AND_PREPARATION"] = "DATA_SELECTION_AND_PREPARATION";
    TaskTemplateNameEnum["PRINT"] = "PRINT";
    TaskTemplateNameEnum["PRINT_PREPARATION"] = "PRINT_PREPARATION";
    TaskTemplateNameEnum["CREATE_FIRST_ARTICLE_DRAFT_AND_DOOH"] = "CREATE_FIRST_ARTICLE_DRAFT_AND_DOOH";
    TaskTemplateNameEnum["CREATE_SECOND_ARTICLE_DRAFT_AND_DOOH"] = "CREATE_SECOND_ARTICLE_DRAFT_AND_DOOH";
    TaskTemplateNameEnum["CREATE_ARTICLE_DRAFT_AND_TEASER"] = "CREATE_ARTICLE_DRAFT_AND_TEASER";
    TaskTemplateNameEnum["CREATE_AD"] = "CREATE_AD";
    TaskTemplateNameEnum["FINALIZE_ARTICLE_AND_DOOH_LANDINGPAGE"] = "FINALIZE_ARTICLE_AND_DOOH_LANDINGPAGE";
    TaskTemplateNameEnum["FINALIZE_ARTICLE_AND_TEASER_LANDINGPAGE"] = "FINALIZE_ARTICLE_AND_TEASER_LANDINGPAGE";
    TaskTemplateNameEnum["APPROVAL"] = "APPROVAL";
    TaskTemplateNameEnum["APPROVE_ARTICLE_LANDINGPAGE_AND_DOOH"] = "APPROVE_ARTICLE_LANDINGPAGE_AND_DOOH";
    TaskTemplateNameEnum["APPROVE_ARTICLE_AND_TEASER_LANDINGPAGE"] = "APPROVE_ARTICLE_AND_TEASER_LANDINGPAGE";
    TaskTemplateNameEnum["APPROVE_EMAIL"] = "APPROVE_EMAIL";
    TaskTemplateNameEnum["APPROVE_EMAIL_INITIAL"] = "APPROVE_EMAIL_INITIAL";
    TaskTemplateNameEnum["APPROVE_EMAIL_REMINDER"] = "APPROVE_EMAIL_REMINDER";
    TaskTemplateNameEnum["APPROVE_AD"] = "APPROVE_AD";
    TaskTemplateNameEnum["READY_FOR_PRINT"] = "READY_FOR_PRINT";
    TaskTemplateNameEnum["HTML_CREATE_EMAIL"] = "HTML_CREATE_EMAIL";
    TaskTemplateNameEnum["HTML_CREATE_EMAIL_INITIAL"] = "HTML_CREATE_EMAIL_INITIAL";
    TaskTemplateNameEnum["HTML_CREATE_EMAIL_REMINDER"] = "HTML_CREATE_EMAIL_REMINDER";
    TaskTemplateNameEnum["CAMPAIGN_PREPARATION"] = "CAMPAIGN_PREPARATION";
    TaskTemplateNameEnum["CAMPAIGN_PREPARATION_PREVIEW_TEST"] = "CAMPAIGN_PREPARATION_PREVIEW_TEST";
    TaskTemplateNameEnum["CAMPAIGN_PREPARATION_TEST"] = "CAMPAIGN_PREPARATION_TEST";
    TaskTemplateNameEnum["OPTIMIZE_AD"] = "OPTIMIZE_AD";
    TaskTemplateNameEnum["POSTAL_DISPATCH"] = "POSTAL_DISPATCH";
    TaskTemplateNameEnum["PROMOTION_ON_SITE"] = "PROMOTION_ON_SITE";
    TaskTemplateNameEnum["REVIEW_PREVIEW_APPROVE_NEWSLETTER"] = "REVIEW_PREVIEW_APPROVE_NEWSLETTER";
    TaskTemplateNameEnum["REVIEW_FEEDBACK_FIRST_ARTICLE_AND_DOOH"] = "REVIEW_FEEDBACK_FIRST_ARTICLE_AND_DOOH";
    TaskTemplateNameEnum["REVIEW_FEEDBACK_SECOND_ARTICLE_AND_DOOH"] = "REVIEW_FEEDBACK_SECOND_ARTICLE_AND_DOOH";
    TaskTemplateNameEnum["REVIEW_FEEDBACK_ARTICLE_AND_TEASER"] = "REVIEW_FEEDBACK_ARTICLE_AND_TEASER";
    TaskTemplateNameEnum["SEND_EMAIL"] = "SEND_EMAIL";
    TaskTemplateNameEnum["SEND_EMAIL_INITIAL"] = "SEND_EMAIL_INITIAL";
    TaskTemplateNameEnum["SEND_EMAIL_REMINDER"] = "SEND_EMAIL_REMINDER";
    TaskTemplateNameEnum["PREPARE_EMAIL_REMINDER_DISPATCH"] = "PREPARE_EMAIL_REMINDER_DISPATCH";
    TaskTemplateNameEnum["PREPARE_EMAIL_DISPATCH"] = "PREPARE_EMAIL_DISPATCH";
    TaskTemplateNameEnum["PREPARE_EMAIL_REMINDER_DISPATCH_ALT"] = "PREPARE_EMAIL_REMINDER_DISPATCH_ALT";
    TaskTemplateNameEnum["DELIVER_TO_MAILBOX"] = "DELIVER_TO_MAILBOX";
    TaskTemplateNameEnum["DELIVER_NEWSLETTER"] = "DELIVER_NEWSLETTER";
    TaskTemplateNameEnum["BILLING"] = "BILLING";
    TaskTemplateNameEnum["DEBRIEFING"] = "DEBRIEFING";
})(TaskTemplateNameEnum || (TaskTemplateNameEnum = {}));
export var ActorNameEnum;
(function (ActorNameEnum) {
    ActorNameEnum["POST_CH_AG"] = "POST_CH_AG";
    ActorNameEnum["ACCOUNT_NAME_PLACEHOLDER"] = "ACCOUNT_NAME_PLACEHOLDER";
    ActorNameEnum["ACCOUNT_NAME_POST_CH_AG"] = "ACCOUNT_NAME_POST_CH_AG";
})(ActorNameEnum || (ActorNameEnum = {}));
export var SubcontractorNameEnum;
(function (SubcontractorNameEnum) {
    SubcontractorNameEnum["AGENCY"] = "AGENCY";
    SubcontractorNameEnum["AZ_DIRECT"] = "AZ_DIRECT";
    SubcontractorNameEnum["CONVERTO_ATTACKERA"] = "CONVERTO_ATTACKERA";
    SubcontractorNameEnum["PRINTER"] = "PRINTER";
    SubcontractorNameEnum["KUENZLERBACHMANN"] = "KUENZLERBACHMANN";
    SubcontractorNameEnum["LIVESYSTEMS"] = "LIVESYSTEMS";
    SubcontractorNameEnum["LS33"] = "LS33";
    SubcontractorNameEnum["LS33_1"] = "LS33_1";
    SubcontractorNameEnum["LS33_1_LS34_1"] = "LS33_1_LS34_1";
    SubcontractorNameEnum["LS33_1_LS35"] = "LS33_1_LS35";
    SubcontractorNameEnum["LS35"] = "LS35";
    SubcontractorNameEnum["MISS_WOLF"] = "MISS_WOLF";
    SubcontractorNameEnum["NAU_CH"] = "NAU_CH";
    SubcontractorNameEnum["NEURONS"] = "NEURONS";
    SubcontractorNameEnum["POST_BRANCH"] = "POST_BRANCH";
    SubcontractorNameEnum["POST_COMMUNICATION"] = "POST_COMMUNICATION";
    SubcontractorNameEnum["SBB"] = "SBB";
})(SubcontractorNameEnum || (SubcontractorNameEnum = {}));
export var ServiceTypeEnum;
(function (ServiceTypeEnum) {
    ServiceTypeEnum["ADDRESSIERTE_MAILINGS_SERVICE_PRINT_POSTKARTE_A6_REMINDER"] = "ADDRESSIERTE_MAILINGS_SERVICE_PRINT_POSTKARTE_A6_REMINDER";
    ServiceTypeEnum["ADDRESSIERTE_MAILINGS_PRINT_FLYER"] = "ADDRESSIERTE_MAILINGS_PRINT_FLYER";
    ServiceTypeEnum["ADDRESSIERTE_MAILINGS_SERVICE_ADDRESS_MATCH"] = "ADDRESSIERTE_MAILINGS_SERVICE_ADDRESS_MATCH";
    ServiceTypeEnum["ADDRESSIERTE_MAILINGS_SERVICE_ADDRESS_MATCH_POST_REMINDER"] = "ADDRESSIERTE_MAILINGS_SERVICE_ADDRESS_MATCH_POST_REMINDER";
    ServiceTypeEnum["ADDRESSIERTE_MAILINGS_SERVICE_ADDRESSED_MAILING_RETARGETING"] = "ADDRESSIERTE_MAILINGS_SERVICE_ADDRESSED_MAILING_RETARGETING";
    ServiceTypeEnum["ADDRESSIERTE_MAILINGS_SERVICE_PRINT_LETTER"] = "ADDRESSIERTE_MAILINGS_SERVICE_PRINT_LETTER";
    ServiceTypeEnum["ADDRESSIERTE_MAILINGS_SERVICE_PRINT_LETTER_REMINDER"] = "ADDRESSIERTE_MAILINGS_SERVICE_PRINT_LETTER_REMINDER";
    ServiceTypeEnum["ADDRESSIERTE_MAILINGS_SERVICE_PRINT_POSTKARTE_A5"] = "ADDRESSIERTE_MAILINGS_SERVICE_PRINT_POSTKARTE_A5";
    ServiceTypeEnum["ADDRESSIERTE_MAILINGS_SERVICE_PRINT_POSTKARTE_A5_REMINDER"] = "ADDRESSIERTE_MAILINGS_SERVICE_PRINT_POSTKARTE_A5_REMINDER";
    ServiceTypeEnum["ADDRESSIERTE_MAILINGS_SERVICE_PRINT_POSTKARTE_A6"] = "ADDRESSIERTE_MAILINGS_SERVICE_PRINT_POSTKARTE_A6";
    ServiceTypeEnum["ADDRESSIERTE_MAILINGS_SERVICE_PRINT_REMINDER"] = "ADDRESSIERTE_MAILINGS_SERVICE_PRINT_REMINDER";
    ServiceTypeEnum["ADDRESSIERTE_MAILINGS_SERVICE_EMAIL_HTML_INITIAL_POSTAD"] = "ADDRESSIERTE_MAILINGS_SERVICE_EMAIL_HTML_INITIAL_POSTAD";
    ServiceTypeEnum["ADDRESSIERTE_MAILINGS_SERVICE_EMAIL_SETUP"] = "ADDRESSIERTE_MAILINGS_SERVICE_EMAIL_SETUP";
    ServiceTypeEnum["ADDRESSIERTE_MAILINGS_SERVICE_KI_ANALYSIS"] = "ADDRESSIERTE_MAILINGS_SERVICE_KI_ANALYSIS";
    ServiceTypeEnum["ADDRESSED_MAILING_ADDRESS_RENTAL"] = "ADDRESSED_MAILING_ADDRESS_RENTAL";
    ServiceTypeEnum["ADDRESSED_MAILING_ADDRESS_RENTAL_POSTAD"] = "ADDRESSED_MAILING_ADDRESS_RENTAL_POSTAD";
    ServiceTypeEnum["ADDRESSED_MAILING_ADDRESS_RENTAL_RETARGETING"] = "ADDRESSED_MAILING_ADDRESS_RENTAL_RETARGETING";
    ServiceTypeEnum["ADDRESSED_MAILING_ADDRESS_RENTAL_RETARGETING_POSTAD"] = "ADDRESSED_MAILING_ADDRESS_RENTAL_RETARGETING_POSTAD";
    ServiceTypeEnum["ADDRESSED_MAILING_PORTO_B2_LETTER"] = "ADDRESSED_MAILING_PORTO_B2_LETTER";
    ServiceTypeEnum["ADDRESSED_MAILING_PORTO_B2_POSTCARD"] = "ADDRESSED_MAILING_PORTO_B2_POSTCARD";
    ServiceTypeEnum["DOOH_SERVICE_KI_ANALYSIS"] = "DOOH_SERVICE_KI_ANALYSIS";
    ServiceTypeEnum["PRINT_FLYER"] = "PRINT_FLYER";
    ServiceTypeEnum["PRINT_LASCHENMAILING"] = "PRINT_LASCHENMAILING";
    ServiceTypeEnum["EMAIL_PRINT_FLYER"] = "EMAIL_PRINT_FLYER";
    ServiceTypeEnum["EMAIL_SERVICE_ADDRESS_MATCH"] = "EMAIL_SERVICE_ADDRESS_MATCH";
    ServiceTypeEnum["EMAIL_SERVICE_ADDRESS_MATCH_POST_REMINDER"] = "EMAIL_SERVICE_ADDRESS_MATCH_POST_REMINDER";
    ServiceTypeEnum["EMAIL_SERVICE_ADDRESSED_MAILING_RETARGETING"] = "EMAIL_SERVICE_ADDRESSED_MAILING_RETARGETING";
    ServiceTypeEnum["EMAIL_SERVICE_PRINT_LETTER"] = "EMAIL_SERVICE_PRINT_LETTER";
    ServiceTypeEnum["EMAIL_SERVICE_PRINT_LETTER_REMINDER"] = "EMAIL_SERVICE_PRINT_LETTER_REMINDER";
    ServiceTypeEnum["EMAIL_SERVICE_PRINT_POSTKARTE_A5"] = "EMAIL_SERVICE_PRINT_POSTKARTE_A5";
    ServiceTypeEnum["EMAIL_SERVICE_PRINT_POSTKARTE_A5_REMINDER"] = "EMAIL_SERVICE_PRINT_POSTKARTE_A5_REMINDER";
    ServiceTypeEnum["EMAIL_SERVICE_PRINT_POSTKARTE_A6"] = "EMAIL_SERVICE_PRINT_POSTKARTE_A6";
    ServiceTypeEnum["EMAIL_SERVICE_PRINT_POSTKARTE_A6_REMINDER"] = "EMAIL_SERVICE_PRINT_POSTKARTE_A6_REMINDER";
    ServiceTypeEnum["EMAIL_SERVICE_PRINT_REMINDER"] = "EMAIL_SERVICE_PRINT_REMINDER";
    ServiceTypeEnum["EMAIL_SERVICE_EMAIL_HTML_INITIAL_POSTAD"] = "EMAIL_SERVICE_EMAIL_HTML_INITIAL_POSTAD";
    ServiceTypeEnum["EMAIL_SERVICE_EMAIL_SETUP"] = "EMAIL_SERVICE_EMAIL_SETUP";
    ServiceTypeEnum["EMAIL_SERVICE_KI_ANALYSIS"] = "EMAIL_SERVICE_KI_ANALYSIS";
    ServiceTypeEnum["EMAIL_SHIPPING"] = "EMAIL_SHIPPING";
    ServiceTypeEnum["EMAIL_SHIPPING_POSTAD"] = "EMAIL_SHIPPING_POSTAD";
    ServiceTypeEnum["EMAIL_SHIPPING_REMINDER"] = "EMAIL_SHIPPING_REMINDER";
    ServiceTypeEnum["EMAIL_SHIPPING_REMINDER_POSTAD"] = "EMAIL_SHIPPING_REMINDER_POSTAD";
    ServiceTypeEnum["ONLINE_DISPLAY"] = "ONLINE_DISPLAY";
    ServiceTypeEnum["ONLINE_DISPLAY_POST"] = "ONLINE_DISPLAY_POST";
    ServiceTypeEnum["ONLINE_INMAIL_BANNER_POST"] = "ONLINE_INMAIL_BANNER_POST";
    ServiceTypeEnum["ONLINE_SERVICE_KI_ANALYSIS"] = "ONLINE_SERVICE_KI_ANALYSIS";
    ServiceTypeEnum["ONLINE_SPONSORED_CONTENT_NAUCH"] = "ONLINE_SPONSORED_CONTENT_NAUCH";
    ServiceTypeEnum["SERVICE"] = "SERVICE";
    ServiceTypeEnum["SERVICE_ADDRESS_MATCH"] = "SERVICE_ADDRESS_MATCH";
    ServiceTypeEnum["SERVICE_ADDRESS_MATCH_POST"] = "SERVICE_ADDRESS_MATCH_POST";
    ServiceTypeEnum["SERVICE_ADDRESS_MATCH_POST_REMINDER"] = "SERVICE_ADDRESS_MATCH_POST_REMINDER";
    ServiceTypeEnum["SERVICE_DATA_ANALYTICS"] = "SERVICE_DATA_ANALYTICS";
    ServiceTypeEnum["SERVICE_PRINT"] = "SERVICE_PRINT";
    ServiceTypeEnum["SERVICE_PRINT_LETTER"] = "SERVICE_PRINT_LETTER";
    ServiceTypeEnum["SERVICE_PRINT_LETTER_INITIAL"] = "SERVICE_PRINT_LETTER_INITIAL";
    ServiceTypeEnum["SERVICE_PRINT_LETTER_REMINDER"] = "SERVICE_PRINT_LETTER_REMINDER";
    ServiceTypeEnum["SERVICE_PRINT_LETTER_UNADDRESSED"] = "SERVICE_PRINT_LETTER_UNADDRESSED";
    ServiceTypeEnum["SERVICE_PRINT_FLYER_INITIAL"] = "SERVICE_PRINT_FLYER_INITIAL";
    ServiceTypeEnum["SERVICE_PRINT_FLYER_UNADDRESSED"] = "SERVICE_PRINT_FLYER_UNADDRESSED";
    ServiceTypeEnum["SERVICE_PRINT_INITIAL"] = "SERVICE_PRINT_INITIAL";
    ServiceTypeEnum["SERVICE_PRINT_LASCHENMAILING_UNADDRESSED"] = "SERVICE_PRINT_LASCHENMAILING_UNADDRESSED";
    ServiceTypeEnum["SERVICE_PRINT_POSTKARTE_A5"] = "SERVICE_PRINT_POSTKARTE_A5";
    ServiceTypeEnum["SERVICE_PRINT_POSTKARTE_A5_INITIAL"] = "SERVICE_PRINT_POSTKARTE_A5_INITIAL";
    ServiceTypeEnum["SERVICE_PRINT_POSTKARTE_A5_REMINDER"] = "SERVICE_PRINT_POSTKARTE_A5_REMINDER";
    ServiceTypeEnum["SERVICE_PRINT_POSTKARTE_A5_UNADDRESSED"] = "SERVICE_PRINT_POSTKARTE_A5_UNADDRESSED";
    ServiceTypeEnum["SERVICE_PRINT_POSTKARTE_A6"] = "SERVICE_PRINT_POSTKARTE_A6";
    ServiceTypeEnum["SERVICE_PRINT_POSTKARTE_A6_INITIAL"] = "SERVICE_PRINT_POSTKARTE_A6_INITIAL";
    ServiceTypeEnum["SERVICE_PRINT_POSTKARTE_A6_REMINDER"] = "SERVICE_PRINT_POSTKARTE_A6_REMINDER";
    ServiceTypeEnum["SERVICE_PRINT_POSTKARTE_A6_UNADDRESSED"] = "SERVICE_PRINT_POSTKARTE_A6_UNADDRESSED";
    ServiceTypeEnum["SERVICE_PRINT_REMINDER"] = "SERVICE_PRINT_REMINDER";
    ServiceTypeEnum["SERVICE_PRINT_UNADDRESSED"] = "SERVICE_PRINT_UNADDRESSED";
    ServiceTypeEnum["SERVICE_EMAIL_HTML_INITIAL"] = "SERVICE_EMAIL_HTML_INITIAL";
    ServiceTypeEnum["SERVICE_EMAIL_HTML_INITIAL_POSTAD"] = "SERVICE_EMAIL_HTML_INITIAL_POSTAD";
    ServiceTypeEnum["SERVICE_EMAIL_HTML_ADDITIONAL"] = "SERVICE_EMAIL_HTML_ADDITIONAL";
    ServiceTypeEnum["SERVICE_EMAIL_HTML_ADDITIONAL_POSTAD"] = "SERVICE_EMAIL_HTML_ADDITIONAL_POSTAD";
    ServiceTypeEnum["SERVICE_EMAIL_SETUP"] = "SERVICE_EMAIL_SETUP";
    ServiceTypeEnum["SERVICE_EMAIL_SETUP_POSTAD"] = "SERVICE_EMAIL_SETUP_POSTAD";
    ServiceTypeEnum["SERVICE_EMAIL_SETUP_REMINDER_ADDRESSED_POSTAD"] = "SERVICE_EMAIL_SETUP_REMINDER_ADDRESSED_POSTAD";
    ServiceTypeEnum["SERVICE_F12D"] = "SERVICE_F12D";
    ServiceTypeEnum["SERVICE_CAMPAIGN_MANAGEMENT"] = "SERVICE_CAMPAIGN_MANAGEMENT";
    ServiceTypeEnum["SERVICE_KI_ANALYSIS"] = "SERVICE_KI_ANALYSIS";
    ServiceTypeEnum["SERVICE_NATIVE_ADVERTISING"] = "SERVICE_NATIVE_ADVERTISING";
    ServiceTypeEnum["SERVICE_POSTAUTO_NEWSLETTER"] = "SERVICE_POSTAUTO_NEWSLETTER";
    ServiceTypeEnum["SERVICE_POSTAUTO_WIFI"] = "SERVICE_POSTAUTO_WIFI";
    ServiceTypeEnum["SERVICE_SBB_APP"] = "SERVICE_SBB_APP";
    ServiceTypeEnum["SERVICE_SBB_CONFIRMATION_EMAIL"] = "SERVICE_SBB_CONFIRMATION_EMAIL";
    ServiceTypeEnum["SERVICE_SBB_TICKET_MACHINE"] = "SERVICE_SBB_TICKET_MACHINE";
    ServiceTypeEnum["SERVICE_SBB_NEWSLETTER"] = "SERVICE_SBB_NEWSLETTER";
    ServiceTypeEnum["SERVICE_SBB_SWISSPASS_NEWSLETTER"] = "SERVICE_SBB_SWISSPASS_NEWSLETTER";
    ServiceTypeEnum["SERVICE_SBB_WEBSITE"] = "SERVICE_SBB_WEBSITE";
    ServiceTypeEnum["SERVICE_SETUP_ADDRESSED_MAILING"] = "SERVICE_SETUP_ADDRESSED_MAILING";
    ServiceTypeEnum["SERVICE_AD_CREATION"] = "SERVICE_AD_CREATION";
    ServiceTypeEnum["SERVICE_AD_CREATION_ADDRESS_MAILINGS"] = "SERVICE_AD_CREATION_ADDRESS_MAILINGS";
    ServiceTypeEnum["SERVICE_AD_CREATION_DOOH"] = "SERVICE_AD_CREATION_DOOH";
    ServiceTypeEnum["SERVICE_AD_CREATION_EMAIL"] = "SERVICE_AD_CREATION_EMAIL";
    ServiceTypeEnum["SERVICE_AD_CREATION_ONLINE"] = "SERVICE_AD_CREATION_ONLINE";
    ServiceTypeEnum["SERVICE_AD_CREATION_UNADDRESSED"] = "SERVICE_AD_CREATION_UNADDRESSED";
    ServiceTypeEnum["SOCIAL_MEDIA_CUSTOM_AUDIENCE"] = "SOCIAL_MEDIA_CUSTOM_AUDIENCE";
    ServiceTypeEnum["SOCIAL_MEDIA_SETUP"] = "SOCIAL_MEDIA_SETUP";
    ServiceTypeEnum["STATIONARY_DISPENSER_POST_BRANCH"] = "STATIONARY_DISPENSER_POST_BRANCH";
    ServiceTypeEnum["STATIONARY_POST_BRANCH"] = "STATIONARY_POST_BRANCH";
    ServiceTypeEnum["STATIONARY_AD_SPACE_POST_BRANCH"] = "STATIONARY_AD_SPACE_POST_BRANCH";
    ServiceTypeEnum["UNADDRESSED_MAILINGS_PRINT_FLYER"] = "UNADDRESSED_MAILINGS_PRINT_FLYER";
    ServiceTypeEnum["UNADDRESSED_MAILINGS_SERVICE_PRINT_LETTER"] = "UNADDRESSED_MAILINGS_SERVICE_PRINT_LETTER";
    ServiceTypeEnum["UNADDRESSED_MAILINGS_SERVICE_PRINT_POSTKARTE_A5"] = "UNADDRESSED_MAILINGS_SERVICE_PRINT_POSTKARTE_A5";
    ServiceTypeEnum["UNADDRESSED_MAILINGS_SERVICE_PRINT_POSTKARTE_A6"] = "UNADDRESSED_MAILINGS_SERVICE_PRINT_POSTKARTE_A6";
    ServiceTypeEnum["UNADDRESSED_LASCHENMAILING_POSTAGE_SURCHARGE"] = "UNADDRESSED_LASCHENMAILING_POSTAGE_SURCHARGE";
    ServiceTypeEnum["UNADDRESSED_SERVICE_KI_ANALYSIS"] = "UNADDRESSED_SERVICE_KI_ANALYSIS";
})(ServiceTypeEnum || (ServiceTypeEnum = {}));
export var TaskCommentEnum;
(function (TaskCommentEnum) {
    TaskCommentEnum["DELIVER_ALL_DESIGN_ELEMENTS_AND_BRIEFING"] = "DELIVER_ALL_DESIGN_ELEMENTS_AND_BRIEFING";
    TaskCommentEnum["DATA_TRANSFER_VIA_SECURE_UPLOAD_LINK"] = "DATA_TRANSFER_VIA_SECURE_UPLOAD_LINK";
    TaskCommentEnum["INCLUDES_ADDRESS_PREPARATION_FOR_SHIPPING"] = "INCLUDES_ADDRESS_PREPARATION_FOR_SHIPPING";
    TaskCommentEnum["INCLUDES_TESTING_AND_CORRECTIONS"] = "INCLUDES_TESTING_AND_CORRECTIONS";
    TaskCommentEnum["MOVED_TO_POSITION_REMINDER_WITH_KUBA_AZ_DATA"] = "MOVED_TO_POSITION_REMINDER_WITH_KUBA_AZ_DATA";
})(TaskCommentEnum || (TaskCommentEnum = {}));
export var DiscountTypeEnum;
(function (DiscountTypeEnum) {
    DiscountTypeEnum["DISCOUNT"] = "DISCOUNT";
})(DiscountTypeEnum || (DiscountTypeEnum = {}));
